/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddSubscriptionPaymentMethodSuccessResponseFieldsFragment = {
  readonly __typename: 'AddSubscriptionPaymentMethodSuccessResponse';
  readonly paymentMethodToken: string;
  readonly creditCard: {
    readonly __typename?: 'SubscriptionCreditCard';
    readonly id: string;
    readonly cardType: Types.BraintreeCardType;
    readonly lastFour: string;
    readonly expirationMonth: string | null;
    readonly expirationYear: string | null;
    readonly isActive: boolean;
  };
};

export type PaymentMethodAlreadyExistsErrorFieldsFragment = {
  readonly __typename: 'PaymentMethodAlreadyExistsError';
  readonly errorMessage: string;
};

export type UnknownUserErrorFieldsFragment = {
  readonly __typename: 'UnknownUserError';
  readonly errorMessage: string;
};

export type InvalidPaymentMethodFieldsFragment = {
  readonly __typename: 'InvalidPaymentMethod';
  readonly errorMessage: string;
};

export type AddSubscriptionPaymentMethodMutationVariables = Types.Exact<{
  nonce: Types.Scalars['String'];
}>;

export type AddSubscriptionPaymentMethodMutation = {
  readonly __typename?: 'Mutation';
  readonly addSubscriptionPaymentMethod:
    | {
        readonly __typename: 'AddSubscriptionPaymentMethodSuccessResponse';
        readonly paymentMethodToken: string;
        readonly creditCard: {
          readonly __typename?: 'SubscriptionCreditCard';
          readonly id: string;
          readonly cardType: Types.BraintreeCardType;
          readonly lastFour: string;
          readonly expirationMonth: string | null;
          readonly expirationYear: string | null;
          readonly isActive: boolean;
        };
      }
    | { readonly __typename?: 'InvalidPaymentMethod' }
    | {
        readonly __typename: 'PaymentMethodAlreadyExistsError';
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'UnknownUserError';
        readonly errorMessage: string;
      };
};

export type AddSubscriptionPaymentMethodWithInvalidPaymentMethodErrorMutationVariables =
  Types.Exact<{
    nonce: Types.Scalars['String'];
  }>;

export type AddSubscriptionPaymentMethodWithInvalidPaymentMethodErrorMutation =
  {
    readonly __typename?: 'Mutation';
    readonly addSubscriptionPaymentMethod:
      | {
          readonly __typename: 'AddSubscriptionPaymentMethodSuccessResponse';
          readonly paymentMethodToken: string;
          readonly creditCard: {
            readonly __typename?: 'SubscriptionCreditCard';
            readonly id: string;
            readonly cardType: Types.BraintreeCardType;
            readonly lastFour: string;
            readonly expirationMonth: string | null;
            readonly expirationYear: string | null;
            readonly isActive: boolean;
          };
        }
      | {
          readonly __typename: 'InvalidPaymentMethod';
          readonly errorMessage: string;
        }
      | {
          readonly __typename: 'PaymentMethodAlreadyExistsError';
          readonly errorMessage: string;
        }
      | {
          readonly __typename: 'UnknownUserError';
          readonly errorMessage: string;
        };
  };

export const addSubscriptionPaymentMethodMutationMock: ExecutionResult<AddSubscriptionPaymentMethodMutation> =
  {
    data: {
      addSubscriptionPaymentMethod: {
        paymentMethodToken: 'Hello World',
        creditCard: {
          id: 'e509e6ea-9fee-442a-9962-587ce7190430',
          cardType: 'AmEx',
          lastFour: 'Hello World',
          expirationMonth: 'Hello World',
          expirationYear: 'Hello World',
          isActive: true,
        },
        __typename: 'AddSubscriptionPaymentMethodSuccessResponse',
      },
    },
  };

export const addSubscriptionPaymentMethodWithInvalidPaymentMethodErrorMutationMock: ExecutionResult<AddSubscriptionPaymentMethodWithInvalidPaymentMethodErrorMutation> =
  {
    data: {
      addSubscriptionPaymentMethod: {
        paymentMethodToken: 'Hello World',
        creditCard: {
          id: 'da7a7163-ba7e-4da9-ae8a-185e3da00a9a',
          cardType: 'AmEx',
          lastFour: 'Hello World',
          expirationMonth: 'Hello World',
          expirationYear: 'Hello World',
          isActive: false,
        },
        __typename: 'AddSubscriptionPaymentMethodSuccessResponse',
      },
    },
  };
export const AddSubscriptionPaymentMethodSuccessResponseFieldsFragmentDoc = gql`
  fragment AddSubscriptionPaymentMethodSuccessResponseFields on AddSubscriptionPaymentMethodSuccessResponse {
    paymentMethodToken
    creditCard {
      id
      cardType
      lastFour
      expirationMonth
      expirationYear
      isActive
    }
    __typename
  }
`;
export const PaymentMethodAlreadyExistsErrorFieldsFragmentDoc = gql`
  fragment PaymentMethodAlreadyExistsErrorFields on PaymentMethodAlreadyExistsError {
    errorMessage
    __typename
  }
`;
export const UnknownUserErrorFieldsFragmentDoc = gql`
  fragment UnknownUserErrorFields on UnknownUserError {
    errorMessage
    __typename
  }
`;
export const InvalidPaymentMethodFieldsFragmentDoc = gql`
  fragment InvalidPaymentMethodFields on InvalidPaymentMethod {
    errorMessage
    __typename
  }
`;
export const AddSubscriptionPaymentMethodDocument = gql`
  mutation AddSubscriptionPaymentMethod($nonce: String!) {
    addSubscriptionPaymentMethod(paymentNonce: $nonce) {
      ...AddSubscriptionPaymentMethodSuccessResponseFields
      ...PaymentMethodAlreadyExistsErrorFields
      ...UnknownUserErrorFields
    }
  }
  ${AddSubscriptionPaymentMethodSuccessResponseFieldsFragmentDoc}
  ${PaymentMethodAlreadyExistsErrorFieldsFragmentDoc}
  ${UnknownUserErrorFieldsFragmentDoc}
`;

export function useAddSubscriptionPaymentMethodMutation() {
  return Urql.useMutation<
    AddSubscriptionPaymentMethodMutation,
    AddSubscriptionPaymentMethodMutationVariables
  >(AddSubscriptionPaymentMethodDocument);
}
export const AddSubscriptionPaymentMethodWithInvalidPaymentMethodErrorDocument = gql`
  mutation AddSubscriptionPaymentMethodWithInvalidPaymentMethodError(
    $nonce: String!
  ) {
    addSubscriptionPaymentMethod(paymentNonce: $nonce) {
      ...AddSubscriptionPaymentMethodSuccessResponseFields
      ...PaymentMethodAlreadyExistsErrorFields
      ...UnknownUserErrorFields
      ...InvalidPaymentMethodFields
    }
  }
  ${AddSubscriptionPaymentMethodSuccessResponseFieldsFragmentDoc}
  ${PaymentMethodAlreadyExistsErrorFieldsFragmentDoc}
  ${UnknownUserErrorFieldsFragmentDoc}
  ${InvalidPaymentMethodFieldsFragmentDoc}
`;

export function useAddSubscriptionPaymentMethodWithInvalidPaymentMethodErrorMutation() {
  return Urql.useMutation<
    AddSubscriptionPaymentMethodWithInvalidPaymentMethodErrorMutation,
    AddSubscriptionPaymentMethodWithInvalidPaymentMethodErrorMutationVariables
  >(AddSubscriptionPaymentMethodWithInvalidPaymentMethodErrorDocument);
}
